export const StepNames = {
    STEP_VIEW_PRODUCT_DATA: 'step-view-product-data',
    STEP_PERSONAL_DATA: 'step-personal-data',
    STEP_GET_PERSONAL_DATA: 'step-get-personal-data',
    STEP_JOB_DATA: 'step-job-data',
    STEP_CHOOSE_PRODUCT_DATA: 'step-choose-product-data',
};
